import React, { useEffect, useState } from 'react';
import api from '../api';

const CURRENT_YEAR = new Date().getFullYear();

function fmt(v) {
  if (v === null || v === undefined) return '';
  return Number.isInteger(v) ? v : v.toFixed(1);
}

// 로그인한 교사가 수업한 교육내용(지정과목)별로, 반마다 학생들의 시수 중 최대값을 학과/실기로 보여준다.
export default function MobileHours() {
  const [year, setYear] = useState(CURRENT_YEAR);
  const [classtype, setClasstype] = useState('M');
  const [grade, setGrade] = useState(1);
  const [data, setData] = useState({ classes: [], rows: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get('/teacher/class-hours', { params: { year, grade, classtype } })
      .then((res) => {
        if (!cancelled) setData(res.data);
      })
      .catch(() => {
        if (!cancelled) setData({ classes: [], rows: [] });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [year, grade, classtype]);

  const classes = data.classes;
  // 반이 많아져도 숫자가 겹치지 않도록 반 하나당 최소 20px (보통 9개 반까지는 스크롤 없이 한 화면에 들어간다)
  const tableMinWidth = 140 + classes.length * 20;

  return (
    <div className="page mobile-hours-page">
      <div className="card mob-hr-filter">
        <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
          {[CURRENT_YEAR - 1, CURRENT_YEAR, CURRENT_YEAR + 1].map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        <select value={classtype} onChange={(e) => setClasstype(e.target.value)}>
          <option value="M">면장반</option>
          <option value="R">정규반</option>
        </select>
        <span className="mob-hr-grade">
          <select value={grade} onChange={(e) => setGrade(Number(e.target.value))}>
            {[1, 2, 3].map((g) => (
              <option key={g} value={g}>{g}</option>
            ))}
          </select>
          학년
        </span>
      </div>

      <div className="card mob-hr-card">
        <div className="mob-hr-scroll">
          <table className="mob-hr-table" style={{ minWidth: tableMinWidth }}>
            <colgroup>
              <col className="mob-hr-col-name" />
              <col className="mob-hr-col-type" />
              <col className="mob-hr-col-legal" />
              {classes.map((c) => (
                <col key={c} />
              ))}
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2} className="mob-hr-name-head">교육내용</th>
                <th className="mob-hr-legal" />
                {classes.map((c) => (
                  <th key={c}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r) => (
                <React.Fragment key={r.amtcode}>
                  <tr className="mob-hr-first">
                    <td rowSpan={2} className="mob-hr-name">{r.chapter}</td>
                    <td className="mob-hr-type">학과</td>
                    <td className="mob-hr-legal">{fmt(r.legal_thrytime)}</td>
                    {classes.map((c) => (
                      <td key={c}>{fmt(r.classes[String(c)]?.thrytime)}</td>
                    ))}
                  </tr>
                  <tr>
                    <td className="mob-hr-type">실기</td>
                    <td className="mob-hr-legal">{fmt(r.legal_practime)}</td>
                    {classes.map((c) => (
                      <td key={c}>{fmt(r.classes[String(c)]?.practime)}</td>
                    ))}
                  </tr>
                </React.Fragment>
              ))}
              {data.rows.length === 0 && (
                <tr>
                  <td colSpan={3 + classes.length} className="mob-hr-empty">
                    {loading ? '불러오는 중...' : '이 학년/구분에서 수업한 교육내용이 없습니다.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
